import React from "react";
import { Modal, Table, Button, Space, Typography } from "antd";
import { CSVLink } from "react-csv";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import { useIntl } from "react-intl";
import { useLocation, Link } from "react-router-dom";

const { Title } = Typography;

const ExportErrorsModal = ({ visible, onClose, errors }) => {
  const intl = useIntl();
  let location = useLocation();

  if (!errors || !errors.length) return null;

  const columns = [
    {
      title: intl.formatMessage({ id: "app.employees.fullname" }) || "Name",
      dataIndex: "employee_name",
      key: "employee_name",
      render: (text, record) => {
        const url = location.pathname + "/" + record.employee_id;

        return (
          <Link
            style={{ color: "inherit", textDecoration: "underline" }}
            to={{
              pathname: url,
            }}
          >
            <div className="content">{text}</div>
          </Link>
        );
      },
    },
    {
      title: intl.formatMessage({ id: "app.employees.local_id" }) || "Local ID",
      dataIndex: "local_id",
      key: "local_id",
    },
    {
      title: intl.formatMessage({ id: "app.employees.exportError" }) || "Error",
      dataIndex: "error",
      key: "error",
    },
  ];

  // Localized headers for CSV export
  const csvHeaders = [
    {
      label: intl.formatMessage({ id: "app.employees.employee_id" }) || "ID",
      key: "employee_id",
    },
    {
      label: intl.formatMessage({ id: "app.employees.fullname" }) || "Name",
      key: "employee_name",
    },
    {
      label: intl.formatMessage({ id: "app.employees.local_id" }) || "Local ID",
      key: "local_id",
    },
    {
      label: intl.formatMessage({ id: "app.employees.exportError" }) || "Error",
      key: "error",
    },
  ];

  const filename = `employee-export-errors-${moment().format(
    "YYYY-MM-DD"
  )}.csv`;

  return (
    <Modal
      title={
        intl.formatMessage({ id: "app.employees.export.errors" }) ||
        "Export Errors"
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Space>
          <Button key="close" onClick={onClose}>
            {intl.formatMessage({ id: "app.actions.close" }) || "Close"}
          </Button>
          <CSVLink
            key="download"
            data={errors}
            headers={csvHeaders}
            filename={filename}
          >
            <Button type="primary" icon={<DownloadOutlined />}>
              {intl.formatMessage({ id: "app.actions.download_csv" }) ||
                "Download CSV"}
            </Button>
          </CSVLink>
        </Space>,
      ]}
      width={800}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Title level={5}>
          {intl.formatMessage(
            { id: "app.employees.export.errors.count" },
            { count: errors.length }
          ) || `${errors.length} errors found during export`}
        </Title>
        <Table
          columns={columns}
          dataSource={errors.map((error, index) => ({ ...error, key: index }))}
          pagination={null}
          scroll={{ y: 600 }}
          size="small"
        />
      </Space>
    </Modal>
  );
};

export default ExportErrorsModal;
